import { render } from "./BGPRouting.vue?vue&type=template&id=96500104"
import script from "./BGPRouting.vue?vue&type=script&lang=js"
export * from "./BGPRouting.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__